import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';

import { Weighting } from '../../../../../types/entity.types';

import { UPCOMING } from '../../../../../utils/constants';
import { getClassNames } from '../../../../../utils/util';

import NumberPicker from '../../../../common/input/number-picker/NumberPicker';

import './accountability-weightings.scss';

type Props = {
  charityWork: boolean;
  status: string;
  weightings?: Weighting;
  updateWeighting: (key: keyof Weighting, value: number) => void;
};

const AccountabilityWeightings = ({ charityWork, status, weightings, updateWeighting }: Props) => {
  const [open, setOpen] = useState(true);

  const clampNumber = (value: number) => {
    if (value > 100) {
      value = 100;
    } else if (value < 1) {
      value = 0;
    }

    return value;
  };

  return (
    <div
      className={getClassNames('accountability__section', {
        closed: !open
      })}
      data-testid="accountability-weightings"
    >
      <div className="accountability__section__header">
        <p>WEIGHTINGS</p>
        {!open && (
          <FontAwesomeIcon
            className="accountability__section__open-icon"
            icon={faPlus}
            onClick={() => setOpen(true)}
            data-testid="open-icon"
          />
        )}
        {open && (
          <FontAwesomeIcon
            className="accountability__section__close-icon"
            icon={faMinus}
            onClick={() => setOpen(false)}
            data-testid="close-icon"
          />
        )}
      </div>
      {open && (
        <div className="accountability-weightings">
          <div className="accountability-weightings__input">
            <label>Weight</label>
            <NumberPicker
              value={weightings?.weight ?? ''}
              onChange={(value) => updateWeighting('weight', clampNumber(value as number))}
              disabled={status !== UPCOMING}
              hideArrows
            />
            <p>%</p>
          </div>
          <div className="accountability-weightings__input">
            <label>cm's</label>
            <NumberPicker
              value={weightings?.cm ?? ''}
              onChange={(value) => updateWeighting('cm', clampNumber(value as number))}
              disabled={status !== UPCOMING}
              hideArrows
            />
            <p>%</p>
          </div>
          <div className="accountability-weightings__input">
            <label>Steps</label>
            <NumberPicker
              value={weightings?.steps ?? ''}
              onChange={(value) => updateWeighting('steps', clampNumber(value as number))}
              disabled={status !== UPCOMING}
              hideArrows
            />
            <p>%</p>
          </div>
          <div className="accountability-weightings__input">
            <label>Objectives</label>
            <NumberPicker
              value={weightings?.objectives ?? ''}
              onChange={(value) => updateWeighting('objectives', clampNumber(value as number))}
              disabled={status !== UPCOMING}
              hideArrows
            />
            <p>%</p>
          </div>
          {charityWork && (
            <div className="accountability-weightings__input">
              <label>Charity</label>
              <NumberPicker
                value={weightings?.charity ?? ''}
                onChange={(value) => updateWeighting('charity', clampNumber(value as number))}
                disabled={status !== UPCOMING}
                hideArrows
              />
              <p>%</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AccountabilityWeightings;
